import { listStudent, listExercises, listTopic } from '../data-demo'
export default {
  namespaced: true,
  state: {
    viewActive: 0,
    listStudent: listStudent,
    listExercises: listExercises,
    listTopic: listTopic
  },

  getters: {},

  mutations: {
    setViewActive (state, param) {
      state.viewActive = param
    }
  },

  actions: {}
}
